/* eslint-disable */

import React, { useEffect, useState } from 'react';

// material
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import {
  Box,
  Button,
  Typography,
  Container,
  Table,
  Card,
  CardActions,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Alert,
  Stack,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
  Pagination,
  InputLabel,
  Paper,
  Tooltip
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ConfirmAlertDialog from '../components/ConfirmDialog';
// components
import Page from '../components/Page';
import { RouteMoreMenu } from '../components/_dashboard/smartlock';
import AddNewRouteModal from '../components/_dashboard/smartlock/AddNewRouteModal';
import { getEta, HeaderHeight, PageHeaderHeight } from '../Constants';
import useFeatures from '../components/customContextProviders/FeatureContext';
import Header from '../components/navbar/Header';
import { truncateText } from '../utils/Parser';
import NoDataAvailable from '../components/_dashboard/smartlock/NoDataAvailable';
import { DeleteRouteById, GetAllRoutesData } from '../network/Routes';

// ----------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  },
  tableCellStyle: {
    fontSize: {
      xs: '12px',
      md: '14px'
    },
    fontWeight: 700,
    padding: {
      xs: '8px',
      md: '16px'
    },
    backgroundColor: '#FFFFFF'
  },
  tablePaper: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF'
  },
  tableContainer: {
    flexGrow: 1,
    height: `calc(100vh - ${HeaderHeight + PageHeaderHeight + 56 + 40}px)`,
    overflow: 'auto'
  }
}));

const LoaderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50px'
});

const PageHeader = styled('Box')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'start',
  gap: 1,
  flexDirection: 'row !important',
  height: '50px'
}));

export default function Routes() {
  const classes = useStyles();
  const feature = useFeatures();

  const [open, setOpen] = useState(false);
  const [tripRouteList, setTripRouteList] = useState([]);
  const [isAddRouteModalOpen, setIsAddRouteModalOpen] = useState(false);
  const [sortFilterValue, setSortFilterValue] = useState(['created', 'DESC']);
  const [loader, setLoader] = useState(false);
  const [selectedRouteData, setSelectedRouteData] = useState(null);
  const [openConfirmAlertDialog, setOpenConfirmAlertDialog] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [routePagination, setRoutePagination] = useState(null);

  const [confirmAlertDialogMetas, setConfirmAlertDialogMetas] = useState({
    message: '',
    title: '',
    positiveBtnLable: '',
    negativeBtnLabel: ''
  });

  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: ''
  });

  const vertical = 'bottom';
  const horizontal = 'left';

  const handleSnackBarClose = (event, reason) => {
    // if (reason === 'clickaway') {
    //   return;
    // }
    setAlertMetas({ ...alertMetas, snackBarOpened: false });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleSortFilterChange = (event) => {
    const value = event.target.value.split(',');
    setSortFilterValue(value);
  };

  const handleRouteSearch = (value) => {
    setSearch(value);
  };

  const SearchRoute = () => {
    setPage(1);
    getAllRoutes(page, search, sortFilterValue);
  };

  const getAllRoutes = async (page, search, sortFilterValue) => {
    setLoader(true);
    try {
      const res = await GetAllRoutesData(page, search, sortFilterValue);
      if (res) {
        setLoader(false);
        setRoutePagination(res?.data);
        setTripRouteList((tripRouteList) => res?.data?.data);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const deleteRouteById = async (routeId) => {
    try {
      const res = await DeleteRouteById(routeId);
      if (res) {
        setAlertMetas({
          ...alertMetas,
          severity: 'error',
          snackBarOpened: true,
          msg: 'Route Deleted !'
        });
        setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
        getAllRoutes(page, search, sortFilterValue);
      }
    } catch (error) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    }
  };

  const handleUserMoreMenuClick = (action, routeData) => {
    switch (action) {
      case 'deleteroute': {
        setSelectedRouteData(routeData);
        setConfirmAlertDialogMetas({
          ...confirmAlertDialogMetas,
          message: 'Are you sure want to delete this Route ?',
          title: 'Delete',
          positiveBtnLable: 'Confirm',
          negativeBtnLabel: 'Cancel'
        });
        setOpenConfirmAlertDialog(true);
        break;
      }
      case 'editroute': {
        setIsAddRouteModalOpen(true);
        setSelectedRouteData(routeData);
        break;
      }
      default: {
        return;
      }
    }
  };

  const onAddNewRouteModalSubmit = (msg, action) => {
    setAlertMetas({
      ...alertMetas,
      severity: action === 'SUCCESS' ? 'success' : 'error',
      snackBarOpened: true,
      msg: msg
    });
    setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    if (action === 'SUCCESS') {
      getAllRoutes(page, search, sortFilterValue);
    }
  };

  useEffect(() => {
    getAllRoutes(page, search, sortFilterValue);
    return () => {
      setTripRouteList((tripRouteList) => []);
    };
  }, [page, sortFilterValue]);

  return (
    <Page title="Routes">
      <Header
        onOpenSidebar={() => setOpen(true)}
        handleSearch={handleRouteSearch}
        handleSubmit={SearchRoute}
        name="Route Management"
        showSearch={true}
      />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>

      <Container maxWidth="false" disableGutters sx={{ padding: 0 }}>
        <PageHeader>
          {feature?.route?.addRoute && (
            <Button
              variant="outlined"
              size="medium"
              onClick={() => setIsAddRouteModalOpen(true)}
              sx={{
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 10px 19px 1px #EAEAFF'
              }}
            >
              Add Route
            </Button>
          )}
          <FormControl size="small" data-testid="route-sort-by">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 600 }}>
                Sort By
              </Typography>
              <Select
                sx={{
                  fontSize: { xs: '12px', sm: '14px' },
                  fontWeight: '500',
                  minWidth: '130px',
                  borderRadius: '12px'
                }}
                id="route_sort_filter"
                IconComponent={ExpandMoreIcon}
                value={sortFilterValue.join(',')}
                onChange={handleSortFilterChange}
              >
                <MenuItem className={classes.menuItem} value="name,ASC">
                  Route Name
                </MenuItem>
                <MenuItem className={classes.menuItem} value="created,DESC">
                  Most Recent
                </MenuItem>
                <MenuItem className={classes.menuItem} value="distance,ASC">
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}
                  >
                    <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                      Route Length
                    </Typography>{' '}
                    <ExpandMoreIcon data-testid="expand-more-icon" />
                  </Box>
                </MenuItem>
                <MenuItem className={classes.menuItem} value="distance,DESC">
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}
                  >
                    <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                      Route Length
                    </Typography>{' '}
                    <ExpandLessIcon data-testid="expand-less-icon" />
                  </Box>
                </MenuItem>
                <MenuItem className={classes.menuItem} value="eta,ASC">
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}
                  >
                    <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                      ETA
                    </Typography>{' '}
                    <ExpandMoreIcon data-testid="expand-more-icon-eta" />
                  </Box>
                </MenuItem>
                <MenuItem className={classes.menuItem} value="eta,DESC">
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}
                  >
                    <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                      ETA
                    </Typography>{' '}
                    <ExpandLessIcon data-testid="expand-less-icon-eta" />
                  </Box>
                </MenuItem>
              </Select>
            </Box>
          </FormControl>
          {/* <Button variant="contained" size="small" className={classes?.actionButtons}>Export Data</Button> */}
        </PageHeader>

        <Card sx={{ width: '100%' }}>
          <Paper className={classes.tablePaper}>
            <TableContainer className={classes.tableContainer} data-testid="route-data-table">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell width={150} className={classes.tableCellStyle} align="left">
                      Route Name
                    </TableCell>
                    <TableCell width={150} className={classes.tableCellStyle} align="left">
                      Distance
                    </TableCell>
                    <TableCell width={150} className={classes.tableCellStyle} align="left">
                      ETA
                    </TableCell>
                    <TableCell width={150} className={classes.tableCellStyle} align="left">
                      Start Location
                    </TableCell>
                    <TableCell width={150} className={classes.tableCellStyle} align="left">
                      End Location
                    </TableCell>
                    <TableCell
                      width={150}
                      className={classes.tableCellStyle}
                      align="left"
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loader ? (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <LoaderContainer>
                          <CircularProgress size={30} />
                        </LoaderContainer>
                      </TableCell>
                    </TableRow>
                  ) : tripRouteList?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <NoDataAvailable data-testid="no-data-available" />
                      </TableCell>
                    </TableRow>
                  ) : (
                    tripRouteList?.map((row) => (
                      <TableRow
                        key={row?.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            minWidth: '5vw',
                            textWrap: 'nowrap',
                            textTransform: 'capitalize',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px' // Larger screens
                            }
                          }}
                        >
                          {row?.name ? row?.name : '---'}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: '5vw',
                            textWrap: 'nowrap',
                            textTransform: 'capitalize',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px' // Larger screens
                            }
                          }}
                        >
                          {(row?.distance / 1000).toFixed(2)} km
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: '5vw',
                            textWrap: 'nowrap',
                            textTransform: 'capitalize',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px' // Larger screens
                            }
                          }}
                        >
                          {row?.eta ? getEta(row?.eta) : '---'}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: '5vw',
                            textWrap: 'nowrap',
                            textTransform: 'capitalize',
                            cursor: 'pointer',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px' // Larger screens
                            }
                          }}
                        >
                          <Tooltip placement="top" title={row?.startLocation?.address}>
                            {row?.startLocation?.address !== undefined
                              ? truncateText(row?.startLocation?.address, 30)
                              : '---'}
                          </Tooltip>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: '5vw',
                            textWrap: 'nowrap',
                            textTransform: 'capitalize',
                            cursor: 'pointer',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px' // Larger screens
                            }
                          }}
                        >
                          <Tooltip placement="top" title={row?.endLocation?.address}>
                            {row?.endLocation?.address !== undefined
                              ? truncateText(row?.endLocation?.address, 30)
                              : '---'}
                          </Tooltip>
                        </TableCell>
                        {Object.values(feature?.route).some((value) => value) && (
                          <TableCell
                            align="right"
                            sx={{
                              padding: {
                                xs: '8px',
                                md: '16px'
                              }
                            }}
                          >
                            <RouteMoreMenu
                              handleUser={row}
                              handleClicks={(e) => handleUserMoreMenuClick(e, row)}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {tripRouteList?.length !== 0 && (
              <Stack
                sx={{
                  marginTop: '10px',
                  marginBottom: '10px'
                }}
              >
                <Pagination
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                  count={routePagination?.totalPages}
                  showFirstButton
                  showLastButton
                  onChange={handlePageChange}
                  page={page}
                  total={routePagination?.total}
                />
              </Stack>
            )}
          </Paper>
        </Card>

        {isAddRouteModalOpen && (
          <AddNewRouteModal
            openAssignedModal={isAddRouteModalOpen}
            setIsAddRouteModalOpen={setIsAddRouteModalOpen}
            onAction={(msg, action) => onAddNewRouteModalSubmit(msg, action)}
            data={selectedRouteData}
            setSelectedRouteData={setSelectedRouteData}
          />
        )}

        <ConfirmAlertDialog
          openConfirmAlertDialog={openConfirmAlertDialog}
          message={confirmAlertDialogMetas?.message}
          title={confirmAlertDialogMetas?.title}
          positiveBtnLable={confirmAlertDialogMetas?.positiveBtnLable}
          negativeBtnLable={confirmAlertDialogMetas?.negativeBtnLabel}
          handleClose={() => setOpenConfirmAlertDialog(false)}
          handlePositiveClose={() => {
            deleteRouteById(selectedRouteData?.id);
            setOpenConfirmAlertDialog(false);
          }}
          handleNegativeClose={() => setOpenConfirmAlertDialog(false)}
        />
      </Container>
    </Page>
  );
}
